/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.23",
    versionName: "0.2.0-nightly.2026.1.23",
    versionChannel: "nightly",
    buildDate: "2026-01-23T00:10:30.448Z",
    commitHash: "9ad8ffa599a19d22b77f274cdf4c676e0b7d5754",
};
